import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, Routes } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const expectedRole: string[] | undefined = route.data?.['expectedRole'];
    if (!expectedRole) {
      return of(true);
    }

    return this.authService.isLogin$.pipe(
      filter(loggedIn => loggedIn),
      take(1),
      map(() => this.evaluateAccess(expectedRole))
    );
  }

  private evaluateAccess(expectedRole: string[]): boolean {
    const role = this.authService.user?.role;
    if (!role) {
      this.router.navigate(['/access-denied'], { queryParams: {} });
      return false;
    }
    if (expectedRole.includes(role)) {
      return true;
    }
    this.router.navigate(['/forbidden'], { queryParams: {} });
    return false;
  }

  canAccessRoute(path: string): boolean {
    const matchedRoute = this.findRouteByPath(path.substring(1));
    if (!matchedRoute?.data?.['expectedRole']) return false;
    const expectedRole: string[] = matchedRoute.data['expectedRole'];
    const role = this.authService.user?.role;
    return role ? expectedRole.includes(role) : false;
  }

  private findRouteByPath(path: string): Route | null {
    return this.findRoute(this.router.config, path);
  }

  private findRoute(routes: Routes, path: string): Route | null {
    for (const route of routes) {
      if (route.path === path) {
        return route;
      }
      if (route.children) {
        const childMatch = this.findRoute(route.children, path);
        if (childMatch) {
          return childMatch;
        }
      }
    }
    return null;
  }

}
